import React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { GlobalStyles } from "./GlobalStyles.js";
import { CartProvider } from "./context/CartContext";

import MenuBar from "./components/MenuBar/MenuBar";
import Footer from "./components/Footer/Footer";

import MenuPage from "./pages/MenuPage/MenuPage";
import AboutPage from "./pages/AboutPage/AboutPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import RegisterPage from "./pages/RegisterPage/RegisterPage";
import QualityPage from "./pages/QualityPage/QualityPage";
import ContactPage from "./pages/ContactPage/ContactPage";
import CartPage from "./pages/CartPage/CartPage.jsx";

import ChangePasswordPage from "./pages/ChangePasswordPage/ChangePasswordPage";
import UpdatePasswordPage from "./pages/UpdatePasswordPage/UpdatePasswordPage";

import ConfirmedUserPage from "./pages/ConfirmedUserPage/ConfirmedUserPage";
import ConfirmedUserErrorPage from "./pages/ConfirmedUserErrorPage/ConfirmedUserErrorPage";

import TermsAndConditionsPage from "./pages/TermsAndConditionsPage/TermsAndConditionsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage/PrivacyPolicyPage";

import AdminStocPage from "./pages/AdminStocPage/AdminStocPage";
import EmployeeStockPage from "./pages/EmployeeStockPage/EmployeeStockPage";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import PlasareComandaPage from "./pages/PlasareComandaPage/PlasareComandaPage";
import PlataRezultatPage from "./pages/PlataRezultatPage/PlataRezultatPage";
import ComenziPage from "./pages/ComenziPage/ComenziPage.jsx";

import CookiesPage from "./pages/Cookies/CookiesPage";
import CookieBanner from "./pages/Cookies/CookiesBanner";

import CouponPopup from "./components/CouponPopup/CouponPopup";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <CartProvider>
        <GlobalStyles />

        <CouponPopup />
        <MenuBar />

        <Routes>
          <Route path="/" element={<MenuPage />} />
          <Route path="/despre" element={<AboutPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/changepsw" element={<ChangePasswordPage />} />
          <Route path="/updatepsw" element={<UpdatePasswordPage />} />
          <Route path="/confirmed-user" element={<ConfirmedUserPage />} />
          <Route
            path="/confirmed-user-error"
            element={<ConfirmedUserErrorPage />}
          />
          <Route path="/calitate" element={<QualityPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/cos" element={<CartPage />} />
          <Route
            path="/termeni-si-conditii"
            element={<TermsAndConditionsPage />}
          />
          <Route
            path="/politica-de-confidentialitate"
            element={<PrivacyPolicyPage />}
          />
          <Route path="/stoc" element={<AdminStocPage />} />
          <Route path="/employee-stock" element={<EmployeeStockPage />} />{" "}
          <Route path="/profil" element={<ProfilePage />} />
          <Route path="/plasare-comanda" element={<PlasareComandaPage />} />
          <Route path="/plata/rezultat" element={<PlataRezultatPage />} />
          <Route path="/comenzi" element={<ComenziPage />} />{" "}
          <Route path="/cookies" element={<CookiesPage />} />
        </Routes>

        <Footer />
        <CookieBanner />
      </CartProvider>
    </Router>
  );
}
